"use client";

import { c as _c } from "react/compiler-runtime";
import React, { memo } from "react";
import Link from "next/link";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { getImageProps } from "next/image";
import HeroMobileBg from "@/assets/images/v2/hero-mobile-bg.webp";
const BEST_SELLER_URL = "/listing/the-best-sellers?id=10";
export const MobileHero = memo(() => {
  const $ = _c(9);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = getImageProps({
      alt: "Tooffi \u2014 Gifts from India's Most Passionate Creators",
      src: HeroMobileBg,
      fill: true,
      fetchPriority: "high",
      loading: "eager",
      sizes: "(max-width: 1024px) 100vw, 1px"
    });
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    props: t1
  } = t0;
  let mobileProps;
  let mobileSrcSet;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    const {
      srcSet: t2,
      alt: _mobileAlt,
      ...t3
    } = t1;
    mobileSrcSet = t2;
    mobileProps = t3;
    $[1] = mobileProps;
    $[2] = mobileSrcSet;
  } else {
    mobileProps = $[1];
    mobileSrcSet = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="z-0 absolute inset-0"><picture className="absolute inset-0 w-full h-full"><source media="(max-width: 1023px)" srcSet={mobileSrcSet} /><source media="(min-width: 1024px)" srcSet="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" /><img alt={"Tooffi \u2014 Gifts from India's Most Passionate Creators"} {...mobileProps} className="object-cover opacity-90 w-full h-full absolute inset-0" /></picture><div className="z-[1] bg-black/50 absolute inset-0" /></div>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="text-[#97F4DF]">Discover India's</span>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  let t5;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <h2 className="font-lora text-white mb-6 text-3xl leading-[1.1]">{t3} <br />Most Beautiful Gifts.</h2>;
    t5 = <p className="max-w-md font-outfit text-white mb-8 text-base leading-[1.625]">{"Craft coffee, artisanal tea, d\xE9cor, art, chocolates & more - every product from India's finest brands that choose quality over mass production."}</p>;
    t6 = <p className="whitespace-nowrap font-outfit uppercase tracking-wider text-[#FFE088] mb-8 text-sm leading-5">Proudly Made in India.</p>;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t4 = $[5];
    t5 = $[6];
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="bg-[#F7F3F2] items-center h-[600px] flex relative overflow-hidden w-full">{t2}<div className="z-20 max-w-2xl px-6 relative">{t4}{t5}{t6}<Link href={BEST_SELLER_URL} prefetch={true}><Button size="lg" className="bg-gradient-to-br from-[#005F52] to-[#037A6A] font-lora tracking-[0.05em] text-white shadow-xl rounded-full flex items-center gap-3 py-7 px-10 text-base font-extrabold leading-6 transition-transform duration-150 ease-out hover:scale-[1.02]" aria-label="Explore Collection">EXPLORE COLLECTION<ArrowRight className="size-5" strokeWidth={2.5} /></Button></Link></div></div>;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  return t7;
});
MobileHero.displayName = "MobileHero";